window.addEventListener('DOMContentLoaded', (event) => {
  if ((window.location.href.indexOf("fr/open-an-account?utm_campaign=lecoindesentrepreneurs&utm_medium=article&utm_source=affiliate") > -1)) {
    replaceHeaderWithImage('https://editor-assets.abtasty.com/48341/5fc8b95b999e21606990171.png');
  } else if ((window.location.href.indexOf("fr/open-an-account?utm_campaign=leblogdudirigeant&utm_medium=article&utm_source=affiliate") > -1)) {
    replaceHeaderWithImage('https://editor-assets.abtasty.com/48341/602a339d5d57f1613378461.png');
  }
});
